import type { AppMenuButtonProps } from "../../AppFlyoutAnchor/next";
import { AppTooltipContainer } from "@1js/acui-tooltip";
import {
  renderMenuButton_unstable,
  useMenuButtonStyles_unstable,
} from "@fluentui/react-components";
import * as React from "react";
import { useAppSplitButtonMenuButton } from "./useAppSplitButtonMenuButton";

export const AppSplitButtonMenuButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppMenuButtonProps>((props, ref) => {
    const state = useAppSplitButtonMenuButton(props, ref);

    useMenuButtonStyles_unstable(state);

    return (
      <AppTooltipContainer {...props}>
        {renderMenuButton_unstable(state)}
      </AppTooltipContainer>
    );
  })
);

AppSplitButtonMenuButton.displayName = "next/AppSplitButtonMenuButton";
